import { LoginForm } from '@/components/login-form';
import { useAuth } from '@/contexts/auth-context';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function AuthPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect if already authenticated
  useEffect(() => {
    if (user && !loading) {
      console.log('[AuthPage] User authenticated, redirecting to explorer:', user.email);
      navigate('/app/explorer', { replace: true });
    } else if (!loading && !user) {
      console.log('[AuthPage] No user, staying on auth page');
    }
  }, [user, loading, navigate]);

  return (
    <div className="bg-muted flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-4xl">
        <LoginForm />
      </div>
    </div>
  );
}
